import {TrDialog} from "../../Models/tr-dialog";
import {TimeEntryDialog} from "../../Models/time-entry-dialog";
import {EKind, ITimeEntryTypeVm, ProxyContainer} from "../../Data/Data";
import {TimeEntryDataService} from "../../Services/TimeEntryDataService";

const TimeEntryDialogView = require('./time-entry-dialog.html');

interface IScope extends ng.IScope {
  dialog: TrDialog;
  kind: EKind | EKind[];
  entries: ITimeEntryTypeVm[];
  callback: (timeEntry: ITimeEntryTypeVm) => void;
  select: (entry: ITimeEntryTypeVm) => void;
}

export const TimeEntryDialogDirective = [
  TimeEntryDataService.serviceId,
  (timeEntryData: TimeEntryDataService) => {
    return {
      restrict: 'E',
      scope: {instance: '=', kind: '='},
      templateUrl: TimeEntryDialogView,
      link: (scope: IScope, element, attrs) => {
        scope.dialog = new TrDialog();

        scope.$watch('instance', (value: TimeEntryDialog) => {
          value.open = (callback: (timeEntry: ITimeEntryTypeVm) => void) => {
            scope.callback = callback;
            scope.dialog.open();
            timeEntryData.getEntryTypes().then(entries => {
              scope.$apply(() => {
                if(typeof scope.kind === 'number') {
                  scope.entries = entries.filter(e => e.kind === scope.kind);
                }
                if(typeof scope.kind === 'object') {
                  const arr = scope.kind as EKind[];
                  scope.entries = entries.filter(e => arr.some(sk => sk == e.kind));
                }
              });
            });
          };
        });

        scope.select = (entry: ITimeEntryTypeVm) => {
          scope.callback(entry);
          scope.dialog.close();
        };
      },
    }
  }
];
